import { render, staticRenderFns } from "./BoundaryTableSkeleton.vue?vue&type=template&id=6a7be1eb&scoped=true"
import script from "./BoundaryTableSkeleton.vue?vue&type=script&lang=js"
export * from "./BoundaryTableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./BoundaryTableSkeleton.vue?vue&type=style&index=0&id=6a7be1eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7be1eb",
  null
  
)

export default component.exports